// extracted by mini-css-extract-plugin
export default {"mat":"MultiOpeningLineItemSummary_mat__iMz2b","opening":"MultiOpeningLineItemSummary_opening__-eXXN","openingPhoto":"MultiOpeningLineItemSummary_openingPhoto__Dvi+F"};